import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function OccurrenceList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
      {
        dataIndex: ['type', 'name'],
        title: 'Tipo de Ocorrência',
        ...getColumnSearchProps(['type', 'name'], 'Tipo de Ocorrência'),
        sorter: (a, b) => a.type?.name?.localeCompare(b.type?.name),
        sortDirections: ['descend', 'ascend'],
        render: (text, record) => record.type?.name || '',
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="Occurrence"
      toggleStatusRoute="Occurrence"
      requestName="Occurrence"
      route="/Ocorrencia"
      cdPage="id"
      btnNew={true}
    />
  );
}
